// The long-latency units of one TensorCore at the cursor: what each MXU, the XLU,
// the EUP and the PRNG were last asked to do, and whether the core is parked.

import { el, fmtPs } from "./dom.js";
import { unitColor } from "./isa.js";
import { upperIndex } from "./dom.js";

export class UnitBoxes {
  constructor(root, ctx) {
    this.ctx = ctx;
    this.root = root;
    root.classList.add("unitboxes");
    this.core = null;
  }

  setCore(core) {
    if (core === this.core) return;
    this.core = core;
    const m = this.ctx.model;
    this.root.textContent = "";
    this.boxes = new Map();
    if (!core) return;
    const nMxu = m.gen === "v7x" ? 2 : 4;
    const units = [];
    if (core.kind === "tc" && m.hasUnits) {
      for (let i = 0; i < nMxu; i++) units.push(["mxu", i]);
      units.push(["xlu", null], ["eup", null], ["prng", null]);
    }
    for (const [u, idx] of units) {
      const b = el("div", "ubox");
      const t = el("div", "ut", u.toUpperCase() + (idx == null ? "" : idx));
      t.style.color = unitColor(u);
      b.appendChild(t);
      b.appendChild(el("div", "uv dim", "idle"));
      this.root.appendChild(b);
      this.boxes.set(u + (idx == null ? "" : idx), b);
    }
    const w = el("div", "ubox");
    w.appendChild(el("div", "ut", "sync"));
    w.appendChild(el("div", "uv dim", "running"));
    this.root.appendChild(w);
    this.boxes.set("wait", w);
  }

  at(bi) {
    if (!this.core || bi < 0) return;
    const core = this.core, m = this.ctx.model, links = this.ctx.links;
    const last = new Map();
    // Walk back from the cursor's bundle over unit events until every box is filled.
    const hi = upperIndex(core.unitBi, bi + 1);
    for (let k = hi - 1; k >= 0 && last.size < this.boxes.size; k--) {
      const u = core.units[k];
      if (core.unitBi[k] < 0) continue;
      const key = u.unit + (u.unit === "mxu" ? (u.idx ?? 0) : u.unit === "xlu" || u.unit === "eup" || u.unit === "prng" ? "" : "");
      if (!last.has(key)) last.set(key, u);
      if (bi - core.unitBi[k] > 5000) break;
    }
    for (const [key, box] of this.boxes) {
      if (key === "wait") continue;
      const u = last.get(key);
      const v = box.querySelector(".uv");
      box.classList.toggle("live", !!u && bi - u.bi < 8);
      if (!u) { v.textContent = "idle"; v.className = "uv dim"; continue; }
      const extra = Object.entries(u).filter(([k]) => !["step", "unit", "idx", "op", "bi"].includes(k)).slice(0, 4).map(([k, x]) => `${k}=${x}`).join(" ");
      v.className = "uv";
      v.textContent = `${u.op} ${extra}`;
      const ago = bi - u.bi;
      v.appendChild(el("div", "dim", ago === 0 ? "this bundle" : `${ago} bundle${ago === 1 ? "" : "s"} ago`));
    }
    // Parked?
    const t = core.t[bi];
    const w = Array.from(links.waitsByRow.get(core.key) || [], (i) => m.waits[i]).find((x) => x.t0 <= t && t <= (x.open ? m.tEnd : x.t1));
    const wb = this.boxes.get("wait"), wv = wb.querySelector(".uv");
    wb.classList.toggle("live", !!w);
    if (w) { wv.className = "uv"; wv.textContent = `waiting on flag ${w.idx} (${fmtPs(w.stallPs)} stall)`; }
    else { wv.className = "uv dim"; wv.textContent = "running"; }
  }
}
